<template>
<div class=" search_bar map_search_bar">
  <form v-on:submit.prevent>
    <span class="icon_location"></span>
    <autocomplete class="adresse" :input-attrs="{ autofocus: true , placeholder: 'Entrez une adresse, un code postal ou un nom de ville' }" :value="selected" :items="results" :get-label="getLabel" :component-item='adresseTemplate'
      :auto-select-one-item="false" @update-items="search" @item-selected="adresseSelected" @item-clicked="adresseClicked" />
    <div class="search-btn" @click="go" />
  </form>
</div>
</template>

<script>
/* eslint-disable */
import Autocomplete from 'v-autocomplete'
import 'v-autocomplete/dist/v-autocomplete.css'
import axios from 'axios'
import AdresseTemplate from './SearchAdresseTemplate.vue'
import * as eventTypes from '../../bus/event-types.js'
import EventBus from '../../bus'
export default {
  name: 'SearchAdresse',
  components: {
    Autocomplete
  },
  data() {
    return {
      selected: null,
      results: [],
      adresseTemplate: AdresseTemplate
    }
  },
  methods: {
    getLabel(item) {
      return item && item.properties ? item.properties.label : ''
    },
    search(text) {
      axios.get('https://api-adresse.data.gouv.fr/search/?limit=5&q=' + text).then(response => {
        this.results = response.data.features
      }).catch(error => {
        console.error('api-adresse', error)
      })
    },
    adresseSelected(adresse) {
      // On agit directement
      this.selected = adresse
      this.go()
    },
    adresseClicked() {},
    go() {
      // Clic sur le bouton de recherche : première adresse si au moins un résultat
      if (!this.selected) {
        if (this.results && this.results.length > 0) {
          this.selected = this.results[0]
        }
      }
      // Une adresse sélectionnée : événement
      if (this.selected) {
        var geom = this.selected.geometry
        EventBus.$emit(eventTypes.ZOOM_TOGEOM, {
          'geom': geom
        });
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.v-autocomplete-list {
  width: 100%;
}

.v-autocomplete-list-item {
  cursor: pointer;
  background-color: #fff;
  color: #000;
  padding: 10px;
  border-bottom: 1px solid #a8a8a8;
}

.home_search_bar input,
.map_search_bar input {
  border: none;
}

.search-btn {
  width: 40px;
  height: 40px;
  background-image: url('../../assets/img/icon-search.svg');
  background-repeat: no-repeat;
}

.search-btn:hover {
  background-image: url('../../assets/img/icon-search-hover.svg');
}

.search_bar {
  transition: -webkit-box-shadow, box-shadow 1000ms cubic-bezier(0.165, 0.84, 0.44, 1);
}

.search_bar.em {
  -webkit-box-shadow: 5px 5px 10px 0px #f7ca9c;
  box-shadow: 5px 5px 10px 0px #f7ca9c;
  transition: -webkit-box-shadow, box-shadow 200ms cubic-bezier(0.165, 0.84, 0.44, 1);
}

.search_bar.em .icon_location {
  /* filter: invert(.5) sepia(1) saturate(3) hue-rotate(340deg); */
  opacity: 0.6;
}

.search_bar.em input::placeholder {
  color: #f6a451;
  opacity: 1;
}

.search_bar.em input:-ms-input-placeholder,
.search_bar.em input::-ms-input-placeholder {
  color: #f6a451;
  opacity: 1;
}

.main .search_bar .search-btn {
  background-color: #007abc;
  transition: background-color 1000ms cubic-bezier(0.165, 0.84, 0.44, 1);
  cursor: default;
}

.main .search_bar.em .search-btn {
  opacity: 0.8;
  background-color: #fcb66f;
  transition: background-color 200ms cubic-bezier(0.165, 0.84, 0.44, 1);
}
</style>
